import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { CheckIcon } from '@beef/ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const TakeawayFilters = ({ filters, isMobile, onChangeFilter, className }) => {
  const [isChecked, setIsChecked] = useState(false);
  return (
    <div className={cx('wrapper', className, isMobile && 'mobile')}>
      {filters.map((filter) => (
        <span className={cx('checkboxWrap')}>
          <div
            role="button"
            tabIndex={0}
            className={cx('component')}
            onClick={() => {
              setIsChecked(!isChecked);
              onChangeFilter({ ...filter, checked: !filter.checked });
            }}
          >
            <span className={cx('checkbox', filter.checked && 'checked')}>
              <CheckIcon size="xs" fill="#fff" className={cx('icon')} />
            </span>
            <span className={cx('content')}>
              <span className={cx('name')}>{filter.title}</span>
            </span>
          </div>
        </span>
      ))}
    </div>
  );
};

TakeawayFilters.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  filters: PropTypes.array,
  onChangeFilter: PropTypes.func,
};

TakeawayFilters.defaultProps = {
  filters: [],
};

export default TakeawayFilters;
